import { default as indexZ61mnUAOi1Meta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/index.vue?macro=true";
import { default as loginAHvTIGLFA4Meta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/login.vue?macro=true";
import { default as settingsiXFPmrnGYuMeta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/settings.vue?macro=true";
import { default as indexV3Y7uMt9BuMeta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/app/index.vue?macro=true";
import { default as builderPAGHpcFKJqMeta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/builder.vue?macro=true";
import { default as _91code_93mFrAX0Vic7Meta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/category/[code].vue?macro=true";
import { default as indexHcIrAEtKxDMeta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/documents/index.vue?macro=true";
import { default as index06w4IQScP7Meta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/index.vue?macro=true";
import { default as index65NtWAmQ2XMeta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/role/index.vue?macro=true";
import { default as indexo0S4zuoo3XMeta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/tag/index.vue?macro=true";
import { default as index9R5P22UuGwMeta } from "D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/zone/index.vue?macro=true";
export default [
  {
    name: "account___vi",
    path: "/account",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/index.vue")
  },
  {
    name: "account-login___vi",
    path: "/account/login",
    meta: loginAHvTIGLFA4Meta || {},
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: loginAHvTIGLFA4Meta || {},
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/login.vue")
  },
  {
    name: "account-settings___vi",
    path: "/account/settings",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/settings.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/account/settings.vue")
  },
  {
    name: "app___vi",
    path: "/app",
    meta: indexV3Y7uMt9BuMeta || {},
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/app/index.vue")
  },
  {
    name: "app___en",
    path: "/en/app",
    meta: indexV3Y7uMt9BuMeta || {},
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/app/index.vue")
  },
  {
    name: "builder___vi",
    path: "/builder",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/builder.vue")
  },
  {
    name: "builder___en",
    path: "/en/builder",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/builder.vue")
  },
  {
    name: "category-code___vi",
    path: "/category/:code()",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/category/[code].vue")
  },
  {
    name: "category-code___en",
    path: "/en/category/:code()",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/category/[code].vue")
  },
  {
    name: "documents___vi",
    path: "/documents",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/documents/index.vue")
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/documents/index.vue")
  },
  {
    name: "index___vi",
    path: "/",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/index.vue")
  },
  {
    name: "role___vi",
    path: "/role",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/role/index.vue")
  },
  {
    name: "role___en",
    path: "/en/role",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/role/index.vue")
  },
  {
    name: "tag___vi",
    path: "/tag",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/tag/index.vue")
  },
  {
    name: "tag___en",
    path: "/en/tag",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/tag/index.vue")
  },
  {
    name: "zone___vi",
    path: "/zone",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/zone/index.vue")
  },
  {
    name: "zone___en",
    path: "/en/zone",
    component: () => import("D:/FOX/BearTechnology/Projects/MedCAT/MedCAT.Cms/pages/zone/index.vue")
  }
]